// 高版本的antd（antd>=5,antdv>=4）
export function antdModalAdvancedController(dialogController) {
  const { visible, onOk, onCancel, afterClose } = dialogController;
  return {
    open: visible,
    onOk,
    onCancel,
    afterClose
  };
}

export function antdController(dialogController) {
  return dialogController;
}

export function arcoDesignController(dialogController) {
  return dialogController;
}

export function elementPlusController(dialogController) {
  const { visible, afterClose, onOk, onCancel } = dialogController;
  return {
    modelValue: visible,
    closed: afterClose,
    // elementPlus并没有自带确定取消按钮，需要自己实现，预留下面字段给开发者使用
    onOk,
    onCancel
  };
}

export function elementController(dialogController) {
  const { visible, afterClose, onOk, onCancel } = dialogController;
  return {
    visible,
    closed: afterClose,
    // element并没有自带确定取消按钮，需要自己实现，预留下面字段给开发者使用
    onOk,
    onCancel
  };
}

export function dialogController2ModalController(dialogController, adapter) {
  return adapter(dialogController);
}

export function vantController(dialogController) {
  const { visible, afterClose, onOk, onCancel } = dialogController;
  return {
    value: visible,
    closed: afterClose,
    // vant并没有自带确定取消按钮，需要自己实现，预留下面字段给开发者使用
    onOk,
    onCancel
  };
}
